// Xác định endpoint danh sách theo vai trò quản lý (khớp app).
// Phòng hỗ trợ đặc biệt duyệt như giám đốc (dùng endpoint businessManager).
export const SUPPORT_DEPARTMENT_CODES = [
  "PHONG_HANH_CHINH_NHAN_SU",
  "PHONG_KE_TOAN",
  "HO_TRO_BAN_HANG_CRM",
];

export const isSupportDepartment = (code) =>
  SUPPORT_DEPARTMENT_CODES.includes(code || "");

// EMPLOYEE_DEPARTMENT_ENUM của app: SUPPORT_BUSINESS = 0, BUSINESS = 1
export const EMP_DEPARTMENT = { SUPPORT_BUSINESS: 0, BUSINESS: 1 };

// true -> gọi endpoint supportBusinessManager; false -> businessManager.
export const useSupportBusinessEndpoint = (user) =>
  !isSupportDepartment(user?.supportDepartment?.code) &&
  user?.department === EMP_DEPARTMENT.SUPPORT_BUSINESS;

// Mã chức vụ (JOB_TITLE_ENUM của app) - quyết định bộ lọc hiển thị.
export const JOB_TITLE = {
  TGD: "TGD",
  GDCN: "GDCN",
  PTGD: "PTGD",
  TRUONG_VUNG: "TRUONG_VUNG",
  TRUONG_PHONG: "TRUONG_PHONG",
  TRUONG_KHOI: "TRUONG_KHOI",
  NHAN_VIEN: "NHAN_VIEN",
};

/**
 * Chức vụ dùng để dựng lưới bộ lọc (khớp app):
 * người thuộc phòng hỗ trợ đặc biệt được xem như TGD (bộ lọc đầy đủ nhất).
 */
export const filterJobPosition = (user) =>
  isSupportDepartment(user?.supportDepartment?.code)
    ? JOB_TITLE.TGD
    : user?.jobPosition?.code || null;
